import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareReelCardAspectRatioMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  reelCardAspectRatio?: Types.InputMaybe<Types.AssetAggregateCardAspectRatioEnum>;
}>;


export type UpdateShareReelCardAspectRatioMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, appearance: { __typename?: 'AssetAggregateAppearance', reelCardAspectRatio: Types.AssetAggregateCardAspectRatioEnum } } | { __typename?: 'CollectionShare', id: string, appearance: { __typename?: 'AssetAggregateAppearance', reelCardAspectRatio: Types.AssetAggregateCardAspectRatioEnum } } | null } | null };


export const UpdateShareReelCardAspectRatio = /*#__PURE__*/ gql`
    mutation UpdateShareReelCardAspectRatio($shareId: ID!, $reelCardAspectRatio: AssetAggregateCardAspectRatioEnum) {
  updateShare(
    input: {shareId: $shareId, appearance: {reelCardAspectRatio: $reelCardAspectRatio}}
  ) {
    share {
      id
      ... on AssetAggregate {
        appearance {
          reelCardAspectRatio
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareReelCardAspectRatioMutation, UpdateShareReelCardAspectRatioMutationVariables>;

          

          export const useUpdateShareReelCardAspectRatioMutation = (options?:MutationHookOptions<UpdateShareReelCardAspectRatioMutation, UpdateShareReelCardAspectRatioMutationVariables>) => useMutation(UpdateShareReelCardAspectRatio, options);
          

          export type UpdateShareReelCardAspectRatioMutationOptions = MutationHookOptions<UpdateShareReelCardAspectRatioMutation, UpdateShareReelCardAspectRatioMutationVariables>;

          

          export type UpdateShareReelCardAspectRatioMutationResult = ReturnType<typeof useUpdateShareReelCardAspectRatioMutation>[1];

          
